class productMix extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.data = this.querySelector(`#productListJSON${this.sectionId}`) && this.querySelector(`#productListJSON${this.sectionId}`).textContent && JSON.parse(this.querySelector(`#productListJSON${this.sectionId}`).textContent);
    this.count = Number(this.dataset.count);
    this.setClass={
      'open':'prooduct-mix-open',
      'closing':'prooduct-mix-closing',
      'opening':'prooduct-mix-opening'
    }
    this.cartDrawer = document.querySelector('.cart-drawer-container');
  }
  connectedCallback() {
    this.init();
    this.addEventListener('click',(e)=>{
      document.body.classList.add(this.setClass['open']);
      window.sessionStorage.setItem('mixStatu','');
    })
    this.querySelector('.size-chart-wrapper .off-icon').onclick = ()=>{
      this.classList.remove('size-open');
      this.querySelector('.size-chart-wrapper .container').innerHTML = ''
    }
    this.querySelector('.drawer-wrapper .off-icon').onclick = (e)=>{
      e.stopPropagation()
      // document.body.classList.remove(this.setClass['open']);
      this.closeAnimation();
      if(window.sessionStorage.getItem('mixStatu')){
        this.cartDrawer.setAttribute('open','')
        this.cartDrawer.classList.add('menu-opening')
        document.body.classList.add('mini-cart--open');
      }
    }
    this.observeEvent();
  }
  observeEvent(){
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this.querySelector('.off-icon'));
  }
  handleIntersection(entries, _observer) {
    entries.forEach(item => {
      if(item.isIntersecting){
        document.querySelector('.transition-body') && document.querySelector('.transition-body').addEventListener('click', (event) => {
          if(!event.target.classList.contains('transition-body')) return;
          this.closeAnimation();
          if(this.classList.contains('size-open')) this.classList.remove('size-open')
          if(window.sessionStorage.getItem('mixStatu')){
            this.cartDrawer.setAttribute('open','')
            this.cartDrawer.classList.add('menu-opening')
            document.body.classList.add('mini-cart--open');
          }
           event && event.stopImmediatePropagation();
        })
      }
      else{
        document.querySelector('.transition-body') && document.querySelector('.transition-body').removeEventListener('click',()=>{})
      }
    })
  }
  closeAnimation() {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        document.body.classList.add(this.setClass['closing'])
        document.body.classList.remove(this.setClass['open'])
        window.requestAnimationFrame(handleAnimation);
      }
      else{
        if(document.body.classList.contains(this.setClass['closing'])){
          document.body.classList.remove(this.setClass['closing'])
        }
      }
    }
    window.requestAnimationFrame(handleAnimation);
  }
  init(){
   new Promise((resolve, reject)=>{
      let swiperWrapper = this.querySelector('.main-product-image-swiper .swiper-wrapper');
      let mainWrapper = this.querySelectorAll('.drawer-container .list-info-image');
      let temp = '';
      for (let i = 0; i < this.count; i++) {
        temp += `<div class="swiper-slide" style="z-index:${this.count - i}">
          <img 
          data-url="${this.data[i].images[0]}&width=104"
          data-src="${this.data[i].images[0]}&width=104"
          src="${this.data[i].images[0]}&width=104"  width="104"/>
        </div>`
        mainWrapper[i].innerHTML = `
          <img 
          data-url="${this.data[i].images[0]}&width=160"
          data-src="${this.data[i].images[0]}&width=160"
          src="${this.data[i].images[0]}&width=160"  width="160"/>
        `
      }
      swiperWrapper.innerHTML = temp
      resolve()
   })
    .then(()=>{
      // setTimeout(()=>{
      //   let slidesPerView = 'auto';
      //   new Swiper(`.main-product-image-swiper-${this.sectionId}`,{
      //     observer:true,
      //     observeParents:true,
      //     observeSlideChildren: true,
      //     effect: 'coverflow',
      //       loop: true,
      //       grabCursor: true,
      //       centeredSlides: true,
      //       slidesPerView: 'auto',
      //       coverflowEffect: {
      //           rotate: 1,
      //           stretch: 0,
      //           depth: 0,
      //           modifier: 1,
      //           slideShadows: false,
      //       },
      //     // loop:true,
      //     // slidesPerView: 1.5, //设置slider容器能够同时显示的slides数量(carousel模式)。
      //     // spaceBetween: -100, //在slide之间设置距离（单位px）。
      //     // centeredSlides: true, //设置活动块居中
      //     // loop: true,
      //     autoplay: {
      //       stopOnLastSlide: true,
      //       delay: 5000,
      //     },
      //   })
      // },1000)
    })
  }
}
customElements.define('product-mix', productMix);
class drawerMixList extends HTMLElement {
   constructor() {
    super();
    this.num = /^\d+$/;
    this.sizeObject = {}
    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.colorWrapper = this.querySelector('.list-info .product-info .color');
    this.sizeWrapper = this.querySelector('.list-info .product-info .size');
    this.data = this.querySelector(`#drawerMixList${this.sectionId}`) && this.querySelector(`#drawerMixList${this.sectionId}`).textContent && JSON.parse(this.querySelector(`#drawerMixList${this.sectionId}`).textContent);
    this.mainImageWrapper =  this.querySelector('.list-info-image');
    this.sizeChartURL = this.dataset.productUrl;
    this.sizeChartWrapper = this.closest('product-mix')
   }
   connectedCallback() {
     this.reduceData(this.data)
     this.updateCartData()
     this.labelColorEvent();
     this.labelSizeEvent();
     this.addSizeChartEvent();
   }
  reduceData () {
      let res = []
      if(document.querySelector(`#mergeProductVariants${this.getAttribute('data-product-id')}`)){
          let mergeProductVariants = JSON.parse(document.querySelector(`#mergeProductVariants${this.getAttribute('data-product-id')}`).textContent);
          let cardProductVariants = JSON.parse(document.querySelector(`#cardProductVariants${this.getAttribute('data-product-id')}`).textContent);
          res = cardProductVariants.concat(mergeProductVariants);
      }
      else{
          res = this.data;
      }
    
      if(!res) return false;
      // console.log(res)
    let type = [
      'Regular',
      'Tall'
    ]
      let data = res.reduce((total, currentValue) => {
          return {
              ...total,
              ...Object.keys(currentValue).reduce((_r, _c) => {
                // console.log(_c,_r,currentValue)
                  if (_c == 'options') {
                      // currentValue[_c].forEach(item => {
                          // if (item.options) {
                              if (total[_c]) {
                                  total[_c].push({
                                      id: currentValue.id,
                                      size: currentValue.option3 && !this.num.test(currentValue.option3) && !this.num.test(currentValue.option2) ||
                                        currentValue.option3 && this.num.test(currentValue.option3) && !this.num.test(currentValue.option2)
                                        ? currentValue.option3 : currentValue.option2,
                                      color: fitName.indexOf(currentValue.option1) == -1  ? currentValue.option1 : currentValue.option2,
                                      parentId: currentValue.featured_image.product_id,
                                      available:currentValue.available,
                                      img:currentValue.featured_image.src,
                                      info:currentValue.title,
                                      type:type.indexOf(currentValue.option3) > -1 ? currentValue.option3 : ''
                                  })
                              }
                              else {
                                  total[_c] = [{
                                      id: currentValue.id,
                                      size: currentValue.option3 && !this.num.test(currentValue.option3) && !this.num.test(currentValue.option2) ||
                                        currentValue.option3 && this.num.test(currentValue.option3) && !this.num.test(currentValue.option2)
                                        ? currentValue.option3 : currentValue.option2,
                                      color: fitName.indexOf(currentValue.option1) == -1  ? currentValue.option1 : currentValue.option2,
                                      // color: item.option1,
                                      parentId: currentValue.featured_image.product_id,
                                      available:currentValue.available,
                                      img:currentValue.featured_image.src,
                                      info:currentValue.title,
                                      type:type.indexOf(currentValue.option3) > -1 ? currentValue.option3 : ''
                                  }]
                              }
                          // }
                      // });
                  }
                  return total
              }, {})
          }
      }, {});
      let { options } = data;
      let dataSort = [];
      options.forEach((obj) => {
          let array = dataSort[obj['parentId']] || [];
          array.push(obj);
          dataSort[obj['parentId']] = array;
      });
      this.cartDataArray = dataSort;
  }
  updateCartData(){
      let totalArray = []
      for (let target in this.cartDataArray) {
          this.cartDataArray[target].forEach((item,index,array)=>{
              let sizeArray = this.cartDataArray[target][item.color] || []
              let colorArray = this.cartDataArray[target]['COLOR'] || []
              let colorAvailableArray = this.cartDataArray[target]['colorAvailable'] || []
              let imgArray = this.cartDataArray[target]['IMG'] || []
              let arrIndex = index + 1 >= array.length ? array.length - 1 : index + 1 ;
              let typeArray = this.cartDataArray[target]['type'] || []
              let {size,color,type} = array[arrIndex];
              if(size && size != item.size || index ==  array.length - 1 || color != item.color && size == item.size){
                  sizeArray.push(item.size)
                  this.cartDataArray[target][item.color] = sizeArray
              }
              if(color != item.color || index ==  array.length - 1){
                  colorArray.push(item.color)
                  imgArray.push(item.img)
                  colorAvailableArray.push(item.available)
                  this.cartDataArray[target]['COLOR'] = colorArray
                  this.cartDataArray[target]['IMG'] = imgArray
                  this.cartDataArray[target]['colorAvailable'] = colorAvailableArray
              }
              if(type != item.type && typeArray.indexOf(item.type) == -1){
                typeArray.push(item.type)
                this.cartDataArray[target]['type'] = typeArray
              }
          })
      }
    this.updateProductSize();
  }
  updateProductSize(){
    let colorArray = this.cartDataArray[this.productId]['COLOR']
    for (let k = 0; k < colorArray.length; k++) {
      let color = this.cartDataArray[this.productId]['COLOR'][k];
      let size = this.cartDataArray[this.productId][color];
      let temp = '';
      let flag = true
      for (let i = 0; i < size.length; i++) {
        let available = this.availableFilter(color,size[i]) 
        // ${available && flag ? 'is-active' : ''}
        temp += `
          <label class="size ${!available? 'disabled' : ''}  ${size[i].length > 4 ? 'other-size' : ''}" title="${size[i]}" available="${available}">${size[i]}</label>
        `
        available ? flag = false : flag = true;
      }
      this.sizeObject[color] = temp;
    }
  }
  availableFilter(color,size){
    let index = this.cartDataArray[this.productId].findIndex((item)=>{
      return color == item.color && size == item.size
    })
    return this.cartDataArray[this.productId][index].available;
    // return false;
  }
  labelSizeEvent(){
    this.querySelectorAll('.product-size-wrapper label.size').forEach((item,index)=>{
      if(item.getAttribute('available') == 'true' && !this.SIZE){
         this.SIZE = item.getAttribute('title')
         // this.sizeIndex = index;
         // this.sizeWrapper.innerText = this.SIZE;
      }
      const sizes = this.querySelectorAll('.product-size-wrapper label.size')
      item.onclick = ()=>{
        if(index === this.sizeIndex) return;
        item.classList.add('is-active');
        this.SIZE = item.getAttribute('title');
        this.sizeWrapper.innerText = '/ ' + this.SIZE;
        this.sizeIndex != 'undefined' && sizes && sizes[this.sizeIndex] && sizes[this.sizeIndex].classList.remove('is-active');
        this.sizeIndex = index;
        this.filterCartData();
        setTimeout(()=>{
          if(this.classList.contains('no-select') && this.SIZE ){
            this.classList.remove('no-select');
          }
        },200);
      }
    })
  }
  labelColorEvent(){
     let sizeWrapper = this.querySelector('.product-size-wrapper .select-wrapper')
     this.querySelectorAll('.product-color-wrapper label.color').forEach((item,index)=>{
       if(item.classList.contains('is-active')){
         this.COLOR = item.getAttribute('title')
         this.colorIndex = index;
         this.colorWrapper.innerText = this.COLOR;
       }
       item.onclick = ()=>{
         if(index == this.colorIndex) return;
         sizeWrapper.innerHTML = this.sizeObject[item.getAttribute('title')]
         this.mainImageWrapper.innerHTML = `
           <img 
            data-url="${this.cartDataArray[this.productId]['IMG'][index]}&width=160"
            data-src="${this.cartDataArray[this.productId]['IMG'][index]}&width=160"
            src="${this.cartDataArray[this.productId]['IMG'][index]}&width=160"  width="160"
            loading="lazy" is="lazy-image"
            />
         `;
          item.classList.add('is-active');
          this.COLOR = item.getAttribute('title');
          this.colorWrapper.innerText = this.COLOR;
          this.querySelectorAll('.product-color-wrapper label.color')[this.colorIndex].classList.remove('is-active');
          this.SIZE = '';
          this.sizeWrapper.innerText = ''; this.sizeWrapper.innerText = '';
          this.querySelector('add-to-cart').setAttribute("data-variant-id",'');
          this.labelSizeEvent();
          // this.filterCartData();
          this.colorIndex = index;
       }
     })
    sizeWrapper.innerHTML = this.sizeObject[this.COLOR];
  }
  filterCartData(){
    let index = this.cartDataArray[this.productId].findIndex((item)=>{
      return item.color == this.COLOR && item.size == this.SIZE
    })
    let {id} = this.cartDataArray[this.productId][index];
    this.querySelector('add-to-cart').setAttribute("data-variant-id",id);
  }
  addSizeChartEvent(){
    this.querySelector('.product-size-wrapper .description .size-text').onclick = ()=>{
      document.querySelector('product-mix').classList.add('size-open')
      this.getSizeChart()
    }
  }
  getSizeChart(){
    if(this.sizeChartWrapper.querySelector('.size-chart-wrapper .container').innerHTML) return;
    postBodySizeData(this.sizeChartURL).then((res)=>{
      let sizeWrapper = res.data.querySelector('#PopupModal-variant_picker');
      this.sizeChartWrapper.querySelector('.size-chart-wrapper .container').innerHTML = sizeWrapper.querySelector('.rte').innerHTML;
    })
  }
}
customElements.define('drawer-mix-list', drawerMixList);